import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ExpertiseSection from './components/ExpertiseSection';
import PhilosophySection from './components/PhilosophySection';
import ValuesSection from './components/ValuesSection';
import ContactFooter from './components/ContactFooter';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ExpertiseSection />
      <PhilosophySection />
      <ValuesSection />
      <ContactFooter />
    </main>
  );
}